module.exports = __webpack_public_path__ + "img/tool5.0078486.png";